import React, {useState} from "react";
import styles from "./Nav.module.css"
import Button from "../Button/Button";
import MediaQueryUtils from "../../utils/MediaQueryUtils";
import {useDispatch} from "react-redux";
import {setSearch} from "../../actions/IndexActions";
import {useHistory} from "react-router";
import Utils from "../../utils/Utils"
import ModaleAnnulla from "../modaleAnnulla/ModaleAnnulla";

// Voce del menu principale. Era un <div>/<a> con onClick contenente una <label>:
// un <button> ha ruolo, focusabilita' e attivazione da tastiera nativi.
// Il reset di stile (sfondo, bordo, padding, font, cursore) sta nella classe
// .labelMenuCustom, in modo che font-size e colore originali della label non
// vengano sovrascritti da stili inline: la resa grafica resta identica.
function VoceMenu({testo, attiva, onActivate}) {
    return (
        <button
            type="button"
            className={styles.labelMenuCustom}
            aria-current={attiva ? "page" : undefined}
            onClick={onActivate}
        >
            {testo}
        </button>
    );
}

function Nav(props) {

    const dispatch = useDispatch()
    const history = useHistory()
    const sessioneUtente = sessionStorage.getItem("sessioneUtente") ? JSON.parse(sessionStorage.getItem("sessioneUtente")) : {}
    let isPageWide = MediaQueryUtils('(min-width: 1200px)')
    const nazioniPerCodice = JSON.parse(sessionStorage.getItem("nazioniPerCodice"))
    const provincePerCodice = JSON.parse(sessionStorage.getItem("provincePerCodice"))
    const comuniPerCodice = JSON.parse(sessionStorage.getItem("comuniPerCodice"))
    const siglaProvincePerCodice = JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))
    const [menuAperto, setMenuAperto] = useState(false)

    function myFunction() {
        let x = document.getElementById("myLinks");
        if (x.style.display === "block") {
            x.style.display = "none";
            setMenuAperto(false);
        } else {
            x.style.display = "block";
            setMenuAperto(true);
        }
    }


    const iconButton = (
        <div style={{marginRight: "10px"}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#0a5576"
                 className={"bi bi-search ".concat(styles.searchIcon)} viewBox="0 0 16 16">
                <path
                    d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
            </svg>
        </div>
    )

    function onClickButtonSearch() {
        dispatch(setSearch(true))
    }

    return (
        <nav className={"noPrint"} aria-label={"Menu principale"}>
            {isPageWide ?
                <div className={styles.styleSecondFascia}>
                    <div className="row" style={{minHeight: "80px", width: "100%", margin: "0px"}}>
                            <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                                minWidth: "fit-content",
                                justifyContent: "center",
                                display: window.location.pathname === "/login-callback" ? "none" : "flex",
                                alignItems: "center",
                                background: window.location.pathname === "/home" || window.location.pathname === "/cercaAssistenteFamiliare" ? "#0e294b" : ""
                            }}>
                                <VoceMenu
                                    testo={"Home"}
                                    attiva={window.location.pathname === "/home" || window.location.pathname === "/cercaAssistenteFamiliare"}
                                    onActivate={()=> {
                                        if (window.location.pathname === "/wizardRegistro") {
                                            document.getElementById("ButtonHome").click();
                                        }else {
                                            window.location.href="/home"
                                        }
                                    }}
                                />
                            <Button
                                id={"ButtonHome"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaHome"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/home"}}/>}
                                header={"Attenzione!"}
                            />
                            </div>
                        <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: window.location.pathname === "/login-callback" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/doveSiamo" ? "#0e294b" : ""
                        }}>
                                <VoceMenu
                                    testo={"Dove Siamo"}
                                    attiva={window.location.pathname === "/doveSiamo"}
                                    onActivate={()=> {
                                        if (window.location.pathname === "/wizardRegistro") {
                                            document.getElementById("ButtonDove").click();
                                        }else {
                                            window.location.href="/doveSiamo"
                                        }
                                    }}
                                />
                            <Button
                                id={"ButtonDove"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaDove"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/doveSiamo"}}/>}
                                header={"Attenzione!"}
                            />
                        </div>
                        <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: window.location.pathname === "/login-callback" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/faq" ? "#0e294b" : ""
                        }}>
                                <VoceMenu
                                    testo={"FAQ"}
                                    attiva={window.location.pathname === "/faq"}
                                    onActivate={()=> {
                                        if (window.location.pathname === "/wizardRegistro") {
                                            document.getElementById("ButtonFaq").click();
                                        }else {
                                            window.location.href="/faq"
                                        }
                                    }}
                                />
                            <Button
                                id={"ButtonFaq"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaFaq"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/faq"}}/>}
                                header={"Attenzione!"}
                            />
                        </div>
                        {sessioneUtente && sessioneUtente.tipoUtente === "04" &&
                            <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                                minWidth: "fit-content",
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                                background: window.location.pathname === "/annunci" ? "#0e294b" : ""
                            }}>
                                <VoceMenu
                                    testo={"Annunci"}
                                    attiva={window.location.pathname === "/annunci"}
                                    onActivate={() => { window.location.href = "/annunci" }}
                                />
                            </div>
                        }
                        {sessioneUtente && (sessioneUtente.tipoUtente === "01" || sessioneUtente.tipoUtente === "02") &&
                            <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                                minWidth: "fit-content",
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                                background: window.location.pathname === "/annunci" ? "#0e294b" : ""
                            }}>
                                <VoceMenu
                                    testo={"Annunci"}
                                    attiva={window.location.pathname === "/annunci"}
                                    onActivate={() => { window.location.href = "/annunci" }}
                                />
                            </div>
                        }
                        {sessioneUtente && sessioneUtente.tipoUtente === "01" ?
                            <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                                minWidth: "fit-content",
                                justifyContent: "center",
                                display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" ? "none" : "flex",
                                alignItems: "center",
                                background: window.location.pathname === "/registro" || window.location.pathname === "/wizardRegistro" ? "#0e294b" : ""
                            }}>
                                    <VoceMenu
                                        testo={"Registro"}
                                        attiva={window.location.pathname === "/registro" || window.location.pathname === "/wizardRegistro"}
                                        onActivate={()=> {
                                            if (window.location.pathname === "/wizardRegistro") {
                                                document.getElementById("ButtonRegistro").click();
                                            }else {
                                                window.location.href="/registro"
                                            }
                                        }}
                                    />
                                <Button
                                    id={"ButtonRegistro"}
                                    style={{
                                        display:"none",
                                    }}
                                    dataTarget={"modalAnnullaRegistro"}
                                    dataToggle={"modal"}
                                    dataBackdrop={"static"}
                                    dataKeyboard={false}
                                    body={<ModaleAnnulla onClick={()=>{window.location.href = "/registro"}}/>}
                                    header={"Attenzione!"}
                                />
                            </div> :
                            sessioneUtente && sessioneUtente.tipoUtente === "02" ?
                                <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                                    minWidth: "fit-content",
                                    justifyContent: "center",
                                    display: window.location.pathname === "/login-callback" || !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" ? "none" : "flex",
                                    alignItems: "center",
                                    background: window.location.pathname === "/profilo" ? "#0e294b" : ""
                                }}>
                                        <VoceMenu
                                            testo={"Profilo"}
                                            attiva={window.location.pathname === "/profilo"}
                                            onActivate={() =>
                                                Utils.recuperoDatiSintesiCandidato(sessioneUtente.codiceFiscale, dispatch, history, false, "/profilo", comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice, provincePerCodice)}
                                        />
                                </div> : <></>}
                        <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" || sessioneUtente && sessioneUtente.tipoUtente === "04" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/utenti" ? "#0e294b" : ""
                        }}>
                                <VoceMenu
                                    testo={"Utenti"}
                                    attiva={window.location.pathname === "/utenti"}
                                    onActivate={()=> {
                                        if (window.location.pathname === "/wizardRegistro") {
                                            document.getElementById("ButtonUtenti").click();
                                        }else {
                                            window.location.href="/utenti"
                                        }
                                    }}
                                />
                            <Button
                                id={"ButtonUtenti"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaUtenti"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/utenti"}}/>}
                                header={"Attenzione!"}
                            />
                        </div>
                        <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" || sessioneUtente && sessioneUtente.tipoUtente === "04" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/sportelli" ? "#0e294b" : ""
                        }}>
                                <VoceMenu
                                    testo={"Sportelli"}
                                    attiva={window.location.pathname === "/sportelli"}
                                    onActivate={()=> {
                                        if (window.location.pathname === "/wizardRegistro") {
                                            document.getElementById("ButtonSportelli").click();
                                        }else {
                                            window.location.href="/sportelli"
                                        }
                                    }}
                                />
                            <Button
                                id={"ButtonSportelli"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaSportelli"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/sportelli"}}/>}
                                header={"Attenzione!"}
                            />
                        </div>
                        <div className={"col-1 ".concat(styles.stylePagineLi)} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" || sessioneUtente?.ruolo?.toUpperCase() !== "RAF-RDSS"? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/report" ? "#0e294b" : ""
                        }}>
                                <VoceMenu
                                    testo={"Report"}
                                    attiva={window.location.pathname === "/report"}
                                    onActivate={()=> {
                                        if (window.location.pathname === "/wizardRegistro") {
                                            document.getElementById("ButtonReport").click();
                                        }else {
                                            window.location.href="/report"
                                        }
                                    }}
                                />
                            <Button
                                id={"ButtonReport"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaReport"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/report"}}/>}
                                header={"Attenzione!"}
                            />
                        </div>
                        <div className={"col-1"} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" || sessioneUtente && sessioneUtente.tipoUtente === "04" ? "none" : "flex",
                            alignItems: "center"
                        }}>
                            <div className={styles.verticaLine} style={{
                                display: window.location.pathname === "/utenti" ||
                                window.location.pathname === "/sportelli" ||
                                window.location.pathname === "/registro" ||
                                !sessioneUtente ||
                                sessioneUtente && sessioneUtente.tipoUtente === "03" ? "" : "none",
                            }}/>
                        </div>
                        <div className={"col-2"} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" || sessioneUtente && sessioneUtente.tipoUtente === "04" ? "none" : "flex",
                            alignItems: "center"
                        }}>
                            <div>
                                <Button
                                    id={"ricercaButton"}
                                    onClick={onClickButtonSearch}
                                    typeButton={"White"}
                                    disabled={false}
                                    text={window.location.pathname === "/registro" ? "Ricerca Assistente" : window.location.pathname === "/utenti" ? "Ricerca Utente" : window.location.pathname === "/sportelli" ? "Ricerca Sportello" : ""}
                                    icon={iconButton}
                                    style={{
                                        height: "60px", width: "300px",
                                        display: window.location.pathname === "/utenti" ||
                                        window.location.pathname === "/sportelli" ||
                                        window.location.pathname === "/registro" ||
                                        !sessioneUtente ||
                                        sessioneUtente && sessioneUtente.tipoUtente === "03"
                                        || sessioneUtente && sessioneUtente.tipoUtente === "02" ? "" : "none"
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className={styles.topnav}>
                    <div className={"navbar navbar-dark ".concat(styles.styleSecondFascia)}>
                        <div className="container-fluid">
                            <button className="navbar-toggler" type="button" onClick={myFunction}
                                    aria-label={"Apri il menu di navigazione"}
                                    aria-expanded={menuAperto}
                                    aria-controls={"myLinks"}>
                                <span className="navbar-toggler-icon"/>
                            </button>
                        </div>
                    </div>
                    <div id="myLinks" style={{display: "none", backgroundColor: "#1B7EA9"}}>
                        <div className={styles.voceStretta} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: window.location.pathname === "/login-callback" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/home" || window.location.pathname === "/cercaAssistenteFamiliare" ? "#0e294b" : ""
                        }}><VoceMenu
                            testo={"Home"}
                            attiva={window.location.pathname === "/home" || window.location.pathname === "/cercaAssistenteFamiliare"}
                            onActivate={()=> {
                                if (window.location.pathname === "/wizardRegistro") {
                                    document.getElementById("ButtonHome").click();
                                }else {
                                    window.location.href="/home"
                                }
                            }}
                        />
                            <Button
                                id={"ButtonHome"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaHome"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/home"}}/>}
                                header={"Attenzione!"}
                            /></div>
                        <div className={styles.voceStretta} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: window.location.pathname === "/login-callback" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/doveSiamo" ? "#0e294b" : ""
                        }}
                        ><VoceMenu
                            testo={"Dove Siamo"}
                            attiva={window.location.pathname === "/doveSiamo"}
                            onActivate={()=> {
                                if (window.location.pathname === "/wizardRegistro") {
                                    document.getElementById("ButtonDove").click();
                                }else {
                                    window.location.href="/doveSiamo"
                                }
                            }}
                        />
                            <Button
                                id={"ButtonDove"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaDove"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/doveSiamo"}}/>}
                                header={"Attenzione!"}
                            /></div>
                        <div className={styles.voceStretta} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: window.location.pathname === "/login-callback" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/faq" ? "#0e294b" : ""
                        }}
                        ><VoceMenu
                            testo={"FAQ"}
                            attiva={window.location.pathname === "/faq"}
                            onActivate={()=> {
                                if (window.location.pathname === "/wizardRegistro") {
                                    document.getElementById("ButtonFaq").click();
                                }else {
                                    window.location.href="/faq"
                                }
                            }}
                        />
                            <Button
                                id={"ButtonFaq"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaFaq"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/faq"}}/>}
                                header={"Attenzione!"}
                            /></div>
                        {sessioneUtente && sessioneUtente.tipoUtente === "04" &&
                            <div className={styles.voceStretta} style={{
                                minWidth: "fit-content",
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                                background: window.location.pathname === "/annunci" ? "#0e294b" : ""
                            }}>
                                <VoceMenu
                                    testo={"Annunci"}
                                    attiva={window.location.pathname === "/annunci"}
                                    onActivate={() => { window.location.href = "/annunci" }}
                                />
                            </div>
                        }
                        {sessioneUtente && (sessioneUtente.tipoUtente === "01" || sessioneUtente.tipoUtente === "02") &&
                            <div className={styles.voceStretta} style={{
                                minWidth: "fit-content",
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                                background: window.location.pathname === "/annunci" ? "#0e294b" : ""
                            }}>
                                <VoceMenu
                                    testo={"Annunci"}
                                    attiva={window.location.pathname === "/annunci"}
                                    onActivate={() => { window.location.href = "/annunci" }}
                                />
                            </div>
                        }
                        {sessioneUtente && sessioneUtente.tipoUtente === "01" ?
                            <div className={styles.voceStretta} style={{
                                minWidth: "fit-content",
                                justifyContent: "center",
                                display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" ? "none" : "flex",
                                alignItems: "center",
                                background: window.location.pathname === "/registro" || window.location.pathname === "/wizardRegistro" ? "#0e294b" : ""
                            }}
                            >
                                <VoceMenu
                                    testo={"Registro"}
                                    attiva={window.location.pathname === "/registro" || window.location.pathname === "/wizardRegistro"}
                                    onActivate={()=> {
                                        if (window.location.pathname === "/wizardRegistro") {
                                            document.getElementById("ButtonRegistro").click();
                                        }else {
                                            window.location.href="/registro"
                                        }
                                    }}
                                />
                                <Button
                                    id={"ButtonRegistro"}
                                    style={{
                                        display:"none",
                                    }}
                                    dataTarget={"modalAnnullaRegistro"}
                                    dataToggle={"modal"}
                                    dataBackdrop={"static"}
                                    dataKeyboard={false}
                                    body={<ModaleAnnulla onClick={()=>{window.location.href = "/registro"}}/>}
                                    header={"Attenzione!"}
                                />
                            </div> :
                            sessioneUtente && sessioneUtente.tipoUtente === "02" ?
                                <span style={{
                                    minWidth: "fit-content",
                                    justifyContent: "center",
                                    display: window.location.pathname === "/login-callback" || !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" ? "none" : "flex",
                                    alignItems: "center",
                                    background: window.location.pathname === "/profilo" ? "#0e294b" : ""
                                }}>
                                        <VoceMenu
                                            testo={"Profilo"}
                                            attiva={window.location.pathname === "/profilo"}
                                            onActivate={() => Utils.recuperoDatiSintesiCandidato(sessioneUtente.codiceFiscale, dispatch, history, false, "/profilo", comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice, provincePerCodice)}
                                        />
                                    </span> : <></>}
                        <div className={styles.voceStretta} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" || sessioneUtente && sessioneUtente.tipoUtente === "04" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/utenti" ? "#0e294b" : ""
                        }}
                        ><VoceMenu
                            testo={"Utenti"}
                            attiva={window.location.pathname === "/utenti"}
                            onActivate={()=> {
                                if (window.location.pathname === "/wizardRegistro") {
                                    document.getElementById("ButtonUtenti").click();
                                }else {
                                    window.location.href="/utenti"
                                }
                            }}
                        />
                            <Button
                                id={"ButtonUtenti"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaUtenti"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/utenti"}}/>}
                                header={"Attenzione!"}
                            /></div>
                        <div className={styles.voceStretta} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" || sessioneUtente && sessioneUtente.tipoUtente === "04" ? "none" : "flex",
                            alignItems: "center",
                            background: window.location.pathname === "/sportelli" ? "#0e294b" : ""
                        }}
                        ><VoceMenu
                            testo={"Sportelli"}
                            attiva={window.location.pathname === "/sportelli"}
                            onActivate={()=> {
                                if (window.location.pathname === "/wizardRegistro") {
                                    document.getElementById("ButtonSportelli").click();
                                }else {
                                    window.location.href="/sportelli"
                                }
                            }}
                        />
                            <Button
                                id={"ButtonSportelli"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaSportelli"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/sportelli"}}/>}
                                header={"Attenzione!"}
                            /></div>
                        <div className={styles.voceStretta} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" ||   sessioneUtente?.ruolo?.toUpperCase() !== "RAF-RDSS"? "none" : "flex",
                            alignItems: "center"
                        }}
                        >
                            <VoceMenu
                                testo={"Report"}
                                attiva={window.location.pathname === "/report"}
                                onActivate={()=> {
                                    if (window.location.pathname === "/wizardRegistro") {
                                        document.getElementById("ButtonReport").click();
                                    }else {
                                        window.location.href="/report"
                                    }
                                }}
                            />
                            <Button
                                id={"ButtonReport"}
                                style={{
                                    display:"none",
                                }}
                                dataTarget={"modalAnnullaReport"}
                                dataToggle={"modal"}
                                dataBackdrop={"static"}
                                dataKeyboard={false}
                                body={<ModaleAnnulla onClick={()=>{window.location.href = "/report"}}/>}
                                header={"Attenzione!"}
                            />
                        </div>
                        <div className={styles.voceStretta} style={{
                            minWidth: "fit-content",
                            justifyContent: "center",
                            display: !sessioneUtente || sessioneUtente && sessioneUtente.tipoUtente === "03" || sessioneUtente && sessioneUtente.tipoUtente === "02" || sessioneUtente && sessioneUtente.tipoUtente === "04" ? "none" : "flex",
                            alignItems: "center"
                        }}>
                            <Button
                                id={"ricercaButton"}
                                style={{
                                    display: window.location.pathname === "/utenti" ||
                                    window.location.pathname === "/sportelli" ||
                                    window.location.pathname === "/registro" ||
                                    !sessioneUtente ||
                                    sessioneUtente && sessioneUtente.tipoUtente === "03"
                                    || sessioneUtente && sessioneUtente.tipoUtente === "02" ? "" : "none",
                                    width: "300px",
                                    height: "50px"
                                }}
                                onClick={onClickButtonSearch}
                                typeButton={"White"}
                                disabled={false}
                                text={window.location.pathname === "/registro" ? "Ricerca Assistente" : window.location.pathname === "/utenti" ? "Ricerca Utente" : window.location.pathname === "/sportelli" ? "Ricerca Sportello" : ""}
                                icon={iconButton}
                            />
                        </div>
                    </div>
                </div>
            }
        </nav>
    )
}

export default Nav


